/**
 * Transform a value to number
 * @param {string} value value to be transformed to number
 * @returns
 */
function number(value: string) {
  const regex = /^(\d+)$/;
  if (regex.test(value)) {
    return parseInt(value);
  } else {
    return undefined;
  }
}

export default number;
